import { getProtectedInstance } from "../utils/axiosInstance";

export const sCmpUserReportDownloadService = async (fromDate: any, toDate: any,companyId:string) => {
    const response = await getProtectedInstance().get(
        `report/company/${companyId}/user?from_date=${fromDate}&to_date=${toDate}&download=true`
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${response?.headers['content-disposition']?.split('=')[1] || 'UserReport.csv'}`);
    document.body.appendChild(link);
    link.click();
    // return response;
};

export const sCmpUserReportService = async (fromDate: any, toDate: any, companyId: string) => {
    const response = await getProtectedInstance().get(
        `report/company/${companyId}/user?from_date=${fromDate}&to_date=${toDate}&download=false`
    );
    return response.data;
}